import { Avatar, Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const CommenterName = styled(Typography)`
  font-weight: 600;
  margin-right: 5px;
  font-size: 14px;
`;

export const CommentorContainer = styled(Grid)(() => ({
  backgroundColor: "#FFFFFF",
  border: "1px solid #FFFFFF",
  borderRadius: "12px",
  padding: "8px",
}));

export const CommentorAvatar = styled(Avatar)(() => ({
  backgroundColor: "#4A1D9C",
  width: "40px",
  height: "40px",
}));
